import store from '@/store/index'
import axios from "@/api/axios"
import publicFn from '@/publicFn/baseFn'



function getZzLsit(name='', tel='', time1='', time2='') {
    return axios.post(publicFn.getUrl('CustomerReferral_GetList'), {
        "token": {
            "sToken": "E58755AC9907ABA89273FF3A19A55941",
            "TimeSpan": "1755334365"
        },
        "SearchCondition": {
            //"CreateShopId": store.state.bases.shop.ShopId, // 必传
            "CreateCompanyId": store.state.users.user.Company.CompanyId,
            "AddTimeStart": time1,
            "AddTimeEnd": time2,
            "CustomerName": name,
            "CustomerTel": tel,
            CreateShopId: store.state.bases.shop.ShopId,
            ReferralGroup: [1]
        }
    })
}


function getShoop() {
    return axios.post(publicFn.getUrl('CompanyInfo_GetAllCompanyInfo'), {
        "token": {
            "sToken": "E58755AC9907ABA89273FF3A19A55941",
            "TimeSpan": "1755334365"
        },
        "CompanyId": store.state.users.user.Company.CompanyId,
        "Refresh": "1",
        "needHead": 1
    })
}

//获取这个时间段有排班的医生列表
function getScheduleDoctorList(id, time) {
    return axios.post(publicFn.getUrl('Schedule_GetExpertListInSchedules'), {
        "token":{
            "TimeSpan":1517328686398,"sToken":"89090FDE8B6B5247015F6BBB1D85DD38"
        },
        "SearchCondition":{
            "IndexMin": 0,
            "IndexMax": 0,
            "PageIndex": 1,
            "PageSize": 20,
            ScheduleShopId:id,
            ScheduleDateStart: time,
            ScheduleDateEnd: time
        },
        "ReturnInfo": {
            "Expert": {}
        }
    })
}


//获取医生的时间
function getDoctorScheduleList(shopid,exid, time) {
    return axios.post(publicFn.getUrl('Schedule_GetList'), {
        "token": {
            "TimeSpan": 1566827733,
            "sToken": "768DCAFFF869CD61372790C2738012EC"
        },
        "SearchCondition": {
            "IndexMin": 0,
            "IndexMax": 0,
            "PageIndex": 1,
            "PageSize": 100,
            "ScheduleShopId": shopid,
            "ScheduleExpertId": exid,
            ScheduleDateStart: time,
            ScheduleDateEnd: time
        },
        ReturnInfo: {
            ShopFull: {}
        }
    })
}

//顾客转诊
function insertOppointment(comid, shopid, exid, pbid, bz='') {
    return axios.post(publicFn.getUrl('CustomerReferral_Insert'), {
        "token": {
            "TimeSpan": 1593173637,
            "sToken": "DBC7F06D27BA7F2FB54D5D63F11378D1"
        },
        "o": {
            "ReferralCustomerId": store.state.users.CsUser.CustomerId,
            "ReferralToExpertId": exid,
            "ReferralToCompanyId": comid,
            "ReferralToShopId": shopid,
            "ReferralCreateExpertId": store.state.users.employees.ExpertId,
            "ReferralCreateCompanyId": store.state.users.user.Company.CompanyId,
            "ReferralCreateShopId": store.state.bases.shop.ShopId,
            "ReferralChooseId": store.state.physicianVisits.xzConsulting,
            "ReferralType": 1, // 固定1
            "ReferralRemark": bz,
            "ScheduleId": pbid
        },
        ExpertSignPath: store.state.expertClinic.qmUrl
    })
}


function Oppointment_Delete(id) {
    return axios.post(publicFn.getUrl('Oppointment_Delete'), {
        "token": {
            "TimeSpan": 1593173637,
            "sToken": "DBC7F06D27BA7F2FB54D5D63F11378D1"
        },
        OppointmentId: id
    })
}


function getHzdw() {
    return axios.post(publicFn.getUrl('CooperativeCompany_GetList'), {
        "token": {
            "TimeSpan": 1593173637,
            "sToken": "DBC7F06D27BA7F2FB54D5D63F11378D1"
        },
        "SearchCondition": {
            "CC_Id": "",
            "CC_Name": "",
            //"CC_CreateCompanyId": store.state.users.user.Company.CompanyId,//取集团的CompanyId，也就是Company.TopCompanyId
            "CC_UseShopId": store.state.bases.shop.ShopId//自身的shopid
        }
    })
}

function getzzlb(n ='', t='') {
    return axios.post(publicFn.getUrl('CustomerReferral_GetList'), {
        "token": {
            "TimeSpan": 1593173637,
            "sToken": "DBC7F06D27BA7F2FB54D5D63F11378D1"
        },
        "SearchCondition": {
            "CreateCompanyId":  store.state.users.user.Company.CompanyId,
            "CreateShopId": store.state.bases.shop.ShopId, // 必传
            "AddTimeStart": "",
            "AddTimeEnd": "",
            "CustomerName": n,
            "CustomerTel": t,
            "ReferralGroup": [2] // 传int数组，暂定2
        }
    })
}

function getDgzz(id) {
    return axios.post(publicFn.getUrl('CustomerReferral_Get'), {
        "token": {
            "TimeSpan": 1593173637,
            "sToken": "DBC7F06D27BA7F2FB54D5D63F11378D1"
        },
        "SearchCondition": {
            ReferralId: id
        }
    })
}

function addhzZz(obj) {
    return axios.post(publicFn.getUrl('CustomerReferral_Insert'),
        {
            "token": {
                "TimeSpan": 1593173637,
                "sToken": "DBC7F06D27BA7F2FB54D5D63F11378D1"
            },
            o: {
                "ReferralCustomerId": store.state.users.CsUser.CustomerId,
                "ReferralToCompanyId": obj.zrid,
                "ReferralCreateExpertId": store.state.users.employees.ExpertId,
                "ReferralCreateCompanyId": store.state.users.user.Company.CompanyId,
                "ReferralCreateShopId": store.state.bases.shop.ShopId,
                "ReferralChooseId": store.state.physicianVisits.xzConsulting,
                "ReferralType": 1, // 固定1
                "ReferralRemark": obj.bz,
                "CheckTime": obj.jzsj,
                "TaskStartTime": obj.zcsj,
                "TaskContent": obj.zysx,
                "ReferralDeptName": obj.ks,
                "OppointmentTime": obj.yysj,
                "ReferralGroup": 2,
            },
            ExpertSignPath: store.state.expertClinic.qmUrl
    })
}

function addrw(obj) {
    return axios.post(publicFn.getUrl('CustomerReferral_Insert'),
        {
            "token": {
                "TimeSpan": 1593173637,
                "sToken": "DBC7F06D27BA7F2FB54D5D63F11378D1"
            },
            o: {
                "ReferralCustomerId": store.state.users.CsUser.CustomerId,
                "ReferralToCompanyId": obj.gsid,
                "ReferralCreateExpertId": store.state.users.employees.ExpertId,
                "ReferralCreateCompanyId": store.state.users.user.Company.CompanyId,
                "ReferralCreateShopId": store.state.bases.shop.ShopId,
                "ReferralChooseId": store.state.physicianVisits.xzConsulting,
                "ReferralType": 1, // 固定1
                "ReferralRemark": obj.bz,
                ReferralToShopId: obj.dwid,
                TaskType: obj.rwlx,
                TaskStartTime: obj.rwsj,
                TaskContent: obj.rwnr,
                "ReferralGroup": 3,
            },
            ExpertSignPath: store.state.expertClinic.qmUrl
        })
}

function getrwList(n='', t='') {
    return axios.post(publicFn.getUrl('CustomerReferral_GetList'), {
        "token": {
            "TimeSpan": 1593173637,
            "sToken": "DBC7F06D27BA7F2FB54D5D63F11378D1"
        },
        "SearchCondition": {
            "CreateCompanyId": store.state.users.user.Company.CompanyId,
            "CreateShopId": store.state.bases.shop.ShopId, // 必传
            "AddTimeStart": "",
            "AddTimeEnd": "",
            "CustomerName": n,
            "CustomerTel": t,
            "ReferralGroup": [3] // 传int数组，暂定2
        }
    })
}

function deleRw(id) {
    return axios.post(publicFn.getUrl('CustomerReferral_UpdateTaskStatus'), {
        "token": {
            "TimeSpan": 1593173637,
            "sToken": "DBC7F06D27BA7F2FB54D5D63F11378D1"
        },
        "o": {
            "ReferralId": id,
            "TaskStatus": 2
        }
    })
}


//获取专家诊室的总接口PS_all_get
function getExpertClinic(id) {
    return axios.post(publicFn.getUrl('PS_all_get'), {
        "token": {
            "TimeSpan": 1566827733,
            "sToken": "768DCAFFF869CD61372790C2738012EC"
        },
        SearchCondition: {
            S_OP_Type: 'S_OP_Recomm',
            S_OP_Model: 'S_OP_Recomm200512',
            ChooseId: id
        }
    })
}

export {
    getZzLsit,
    getShoop,
    getScheduleDoctorList,
    getDoctorScheduleList,
    insertOppointment,
    Oppointment_Delete,
    getHzdw,
    getzzlb,
    addhzZz,
    addrw,
    getrwList,
    deleRw,
    getDgzz,
    getExpertClinic
}
